// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import redirectToSignInSessionTimeout from "@ces/App/Handlers/XNG/RedirectToSignInSessionTimeout";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateCart } from "@insite/client-framework/Services/CartService";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    UpdateCart as UpdateCartBilling,
    chain as UpdateCartBillingChain,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetUseBillingAddress";
import translate from "@insite/client-framework/Translate";

export const XngUpdateCartBilling: typeof UpdateCartBilling = async props => {
    // Add Tty catch
    try {
        const state = props.getState();
        const { cartId } = state.pages.checkoutShipping;
        if (cartId) {
            const cart = getCartState(state, cartId).value!;
            await updateCart({
                cart: {
                    ...cart,
                    shipToId: props.shipToForEditing.id,
                },
            });
        }
    } catch (error) {
        (props.parameter as any).onError?.(
            error.status === 400 ? error.errorJson.message : translate("There is an error please contact support team"),
        );

        props.dispatch(redirectToSignInSessionTimeout({ errorMessage: error.errorJson.message }));
    }
};
replaceInChain(UpdateCartBillingChain, UpdateCartBilling, XngUpdateCartBilling);
